/**
 * Full-bleed gold low-poly hero backdrop, shared by the Home and Product heros.
 * Renders the given `image` edge-to-edge behind the translucent nav (`-mt-16`),
 * a left scrim for heading contrast, and a bottom fade into the page (see
 * `.hero-products-scrim`). `children` is the hero copy (eyebrow, title, intro,
 * CTAs), constrained to the left column. When `aside` is given (a floating
 * product visual), the hero becomes a two-column layout with `aside` on the
 * right over the backdrop.
 */
export function HeroBackdrop({
  image,
  children,
  aside,
}: {
  image: string;
  children: React.ReactNode;
  aside?: React.ReactNode;
}) {
  return (
    <section className="relative isolate -mt-16 overflow-hidden border-b border-border">
      <img
        src={image}
        alt=""
        aria-hidden="true"
        width={1536}
        height={1024}
        className="pointer-events-none absolute inset-0 -z-20 h-full w-full object-cover object-center"
      />
      <div aria-hidden="true" className="hero-products-scrim absolute inset-0 -z-10" />
      <div className="mx-auto max-w-6xl px-6 pb-24 pt-28 lg:pb-32 lg:pt-36">
        {aside ? (
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <div className="max-w-xl">{children}</div>
            <div className="relative">{aside}</div>
          </div>
        ) : (
          <div className="max-w-xl">{children}</div>
        )}
      </div>
    </section>
  );
}
